import React from "react";

import { Col, Row } from "antd";

function CardHeader(props) {
    return (
        <Row style={{ display: "flex", alignItems: "center"}}>
            <Col span={12}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div>
                        <h2 className={"dados-header"}>Gestão de acessos</h2>
                        <span className="dados-header-subtitle">
                            Gerencie os acessos dos usuários por empresa
                        </span>
                    </div>
                </div>
            </Col>

            <Col span={12}></Col>
        </Row>
    )
}

export default CardHeader;
